<template>
  <el-menu class="navbar" mode="horizontal">
    <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
    <!-- <breadcrumb></breadcrumb> -->
    <div class="avatar-container">
      
      <lang-select class="right-menu-item hover-effect" />

      <el-dropdown trigger="click">
        <div class="avatar-wrapper">        
          <i class="el-icon-location" style="font-size:24px;vertical-align: middle;"></i>
          <span>{{CompanyList.find(p=>p.value==userInfo.CompanyId)?CompanyList.find(p=>p.value==userInfo.CompanyId).label:"账套"}}</span> <i class="el-icon-caret-bottom"></i>   
        </div>
        <el-dropdown-menu class="user-dropdown" slot="dropdown">
          <el-dropdown-item v-for="(item,index) in CompanyList" :key="item.value" :disabled="userInfo.CompanyId==item.value">            
            <span @click="handleLogin(item)" style="display:block;">{{item.label}}</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <el-dropdown trigger="click">
        <div class="avatar-wrapper">        
          <img class="user-avatar" src="../../../assets/avatar.png?imageView2/1/w/32/h/32" style="vertical-align: middle;"  />
          <span  v-if="userInfo" >{{  userInfo.PName }}</span> <i class="el-icon-caret-bottom">  </i>   
        </div>
        <el-dropdown-menu class="user-dropdown" slot="dropdown">
          <!-- <router-link class="inlineBlock" to="/dashboard">
            <el-dropdown-item>
              主页
            </el-dropdown-item>
          </router-link> -->
          <el-dropdown-item divided>
            <span @click="logout" style="display:block;">{{$t('navbar.logOut')}}</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </el-menu>  
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import { Message} from "element-ui";
import { setRights,setLoginCompanyid } from "@/utils/auth";
import {
     GetCompanyList,GetUserRights
} from '@/api/quoteRequest'
import LangSelect from '@/components/LangSelect'

export default {
  components: {
    Breadcrumb,
    Hamburger,
    LangSelect
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'userInfo',
    ])
  },
  data() {
    return {
      CompanyList:[
        {value:'WYSY',label:'广东旺盈实业'},
        {value:'DG2',label:'旺盈彩盒'},
        {value:'DG3',label:'润信精品'},
        {value:'DG4',label:'至美包装'},
        {value:'DG5',label:'东莞华成'},
        {value:'YT',label:'誉天吸塑'},
        {value:'DGXY',label:'新扬印刷'},
      ],
      loginForm: {
        username: "",
        password: "",
        companyid: "",
        isremeber: true
      }
    }
  },
  created(){
    GetCompanyList(0).then(
      response => {
        if (response.Success) {
          this.CompanyList = response.Result;
        }
      }
    ); 
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('toggleSideBar')
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload() 
      })
    },
    handleLogin(Company) {
      setLoginCompanyid(Company.value);
      GetUserRights({ companyID: Company.value,userName:this.userInfo.userName }).then(response => {
        if (response.Success) {
          setRights(JSON.stringify(response.Result));

          this.$router.go(0);

          //this.$router.push({ path: "/quoteQuery/Query",query: { r: Math.random() } });
          
        }
      });
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
    margin-left:20px;
  }
  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }
  .avatar-container {
    height: 50px;
    display: inline-block;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 1002;
    background: #fff;
    padding: 0 20px;
    .avatar-wrapper {
      cursor: pointer;
      .user-avatar {
        height: 24px;
        line-height: 24px;
        width: 24px;
        vertical-align: middle;
        border-radius: 12px;
      }
      span{
        height: 24px;
        line-height: 24px;
        vertical-align: middle;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue